import React, { useState, useEffect } from 'react';
import Breadcumb from '../../Layouts/Breadcumb';
import { Grid, TextField } from '@mui/material';
import DashboardNav from './DashboardNav';
import Select from 'react-select';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { jwtDecode } from 'jwt-decode';
import { Constants } from '../../endPoints';
import { MuiTelInput } from 'mui-tel-input';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const MySwal = withReactContent(Swal);

const Profile = () => {

  const navigate = useHistory();

  const [user, setUser] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {

    const fetchUserData = async () => {

      const accessToken = localStorage.getItem('authToken');

      if (!accessToken) {
        console.error('No access token found');
        return;
      }

      const decodedToken = jwtDecode(accessToken);
      const id = decodedToken.id;

      try {

        const response = await axios.get(`${Constants.userInfoById}/${id}`, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });

        const userData = response.data.data;

        setUser(userData);

        if (userData.country_id) {
          await fetchStates(userData.country_id);
        }

        if (userData.state_id) {
          await fetchCities(userData.state_id);
        }

        setImagePreview(
          userData.image ? `${Constants.imageBaseURL}/${userData.image}` : null
        );

      } catch (error) {
        console.error('Error fetching user data:', error);
      }

    };

    fetchUserData();

  }, []);


  useEffect(() => {

    const fetchCountries = async () => {

      try {

        const response = await axios.get(`${Constants.listCounty}`);
        setCountries(response.data.data);

      } catch (error) {
        console.error('Error fetching countries:', error);
      }

    };

    fetchCountries();

  }, []);



  const fetchStates = async (countryId) => {

    const accessToken = localStorage.getItem('authToken');

    try {

      const response = await axios.get(`${Constants.getStatecountryById}/${countryId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      setStates(response.data.data);
      setCities([]);

    } catch (error) {
      console.error('Error fetching states:', error);
    }

  };



  const fetchCities = async (stateId) => {

    const accessToken = localStorage.getItem('authToken');

    try {

      const response = await axios.get(`${Constants.getCityStateById}/${stateId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      setCities(response.data.data);

    } catch (error) {
      console.error('Error fetching cities:', error);
    }

  };



  const initialValues = user ? {

    name: user.name || '',
    email: user.email || '',
    phone: user.phone || '',
    country_id: user.country_id || '',
    state_id: user.state_id || '',
    city_id: user.city_id || '',
    image: null

  } : {

    name: '',
    email: '',
    phone: '',
    country_id: '',
    state_id: '',
    city_id: '',
    image: null

  };



  const validationSchema = Yup.object({

    name: Yup.string()
      .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed')
      .min(2, 'Name must be at least 2 characters')
      .max(50, 'Name must be less than 50 characters')
      .required('Name is required'),

    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),

    phone: Yup.string()
      .required('Phone is required')
      .test('valid-phone', 'Phone number must be between 8 and 15 digits', (value) => {
        if (!value) return false;
        const digits = value.replace(/\D/g, '');
        return digits.length >= 8 && digits.length <= 15;
      }),

    country_id: Yup.string().required('Country is required'),
    state_id: Yup.string().required('State is required'),
    city_id: Yup.string().required('City is required')

  });



  const onSubmit = async (values, { setSubmitting }) => {

    const accessToken = localStorage.getItem('authToken');

    try {

      const formData = new FormData();

      formData.append('name', values.name);
      formData.append('email', values.email);

      let phone = values.phone || '';
      phone = phone.replace(/^(\+\d{2})(\d{10})$/, '$1 $2');

      formData.append('phone', phone);
      formData.append('country_id', values.country_id);
      formData.append('state_id', values.state_id);
      formData.append('city_id', values.city_id);

      if (values.image) {
        formData.append('image', values.image);
      }

      await axios.put(`${Constants.editRegister}/${user.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`
        }
      });

      MySwal.fire({
        title: 'Success!',
        text: 'User updated successfully.',
        icon: 'success'
      }).then(() => {
        navigate.push('/profile');
      });

    } catch (error) {

      MySwal.fire({
        title: 'Error!',
        text: 'There was an error updating the user.',
        icon: 'error'
      });

      console.error('Error updating user:', error);

    } finally {
      setSubmitting(false);
    }

  };



  // const countryOptions = countries.map(country => ({
  //   value: country.id,
  //   label: (
  //     <div style={{ display: 'flex', alignItems: 'center' }}>
  //       <img
  //         src={`${country.country_symbols}`}
  //         alt={country.country}
  //         style={{ width: '20px', marginRight: '10px' }}
  //       />
  //       {country.country}
  //     </div>
  //   )
  // }));

  const countryOptions = countries.map(country => ({
    value: country.id,
    label: country.country,
    flag: country.country_symbols
  }));



  const stateOptions = states.map(state => ({
    value: state.id,
    label: state.name
  }));



  const cityOptions = cities.map(city => ({
    value: city.id,
    label: city.name
  }));



  const handleImageChange = (e) => {

    const file = e.target.files[0];

    if (file) {

      const reader = new FileReader();

      reader.onloadend = () => {
        setImagePreview(reader.result);
      };

      reader.readAsDataURL(file);

    }

  };



  return (

    <>

      <Breadcumb pagetitle="Profile" />

      <section className="dashboardsec">

        <div className="container mx-auto px-4">

          <Grid container spacing={5}>

            <Grid item lg={3} md={12} sm={12} xs={12}>
              <DashboardNav />
            </Grid>

            <Grid item lg={9} md={12} sm={12} xs={12}>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
              >

                {({ values, setFieldValue, isSubmitting }) => (

                  <Form className="form-profile">

                    <h2 className="text-3xl font-bold mb-4">Account Information</h2>

                    <Grid container spacing={3}>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Field name="name">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Name"
                              fullWidth
                              error={meta.touched && Boolean(meta.error)}
                            // helperText={meta.touched && meta.error}
                            />
                          )}
                        </Field>
                        <ErrorMessage name="name" component="div" className="text-red-500" />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Field name="email" as={TextField} label="Email" fullWidth disabled />
                      </Grid>

                    </Grid>


                    <h2 className="text-3xl font-bold mb-4">Address Information</h2>

                    <Grid container spacing={3}>

                      <Grid item lg={5} md={6} sm={12} xs={12}>

                        {/* <Select
                          options={countryOptions}
                          placeholder="Select Country"
                          isSearchable
                          value={countryOptions.find(option => option.value === values.country_id)}
                          onChange={(option) => {

                            setFieldValue('country_id', option.value);
                            setFieldValue('state_id', '');
                            setFieldValue('city_id', '');

                            fetchStates(option.value);

                          }}
                        /> */}

                        <Select
                          options={countryOptions}
                          placeholder="Select Country"
                          isSearchable
                          value={countryOptions.find(option => option.value === values.country_id)}
                          onChange={(option) => {

                            setFieldValue('country_id', option.value);
                            setFieldValue('state_id', '');
                            setFieldValue('city_id', '');

                            fetchStates(option.value);

                          }}
                          formatOptionLabel={(option) => (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <img
                                src={option.flag}
                                alt={option.label}
                                style={{ width: 20, marginRight: 10 }}
                              />
                              {option.label}
                            </div>
                          )}
                        />

                      </Grid>


                      <Grid item lg={5} md={6} sm={12} xs={12}>

                        <Select
                          options={stateOptions}
                          placeholder="Select State"
                          isSearchable
                          value={stateOptions.find(option => option.value === values.state_id)}
                          onChange={(option) => {

                            setFieldValue('state_id', option.value);
                            setFieldValue('city_id', '');

                            fetchCities(option.value);

                          }}
                        />

                      </Grid>


                      <Grid item lg={5} md={6} sm={12} xs={12}>

                        <Select
                          options={cityOptions}
                          placeholder="Select City"
                          isSearchable
                          value={cityOptions.find(option => option.value === values.city_id)}
                          onChange={(option) => {
                            setFieldValue('city_id', option.value);
                          }}
                        />

                      </Grid>


                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Field name="phone">
                          {({ field, form, meta }) => (
                            <div style={{ position: "relative" }}>

                              <MuiTelInput
                                defaultCountry="AE"
                                value={field.value || ""}
                                onChange={(value) => {
                                  form.setFieldValue("phone", value);
                                }}
                                onBlur={() => form.setFieldTouched("phone", true)}
                                fullWidth

                                // ✅ IMPORTANT
                                error={meta.touched && Boolean(meta.error)}
                                // helperText={meta.touched && meta.error}

                                sx={{
                                  "& .MuiInputBase-input": {
                                    paddingLeft: "15px"
                                  }
                                }}
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      maxHeight: 200,
                                      width: {
                                        xs: "88%",
                                        sm: "280px",
                                        md: "280px"
                                      },
                                      minWidth: {
                                        xs: "88%",
                                        sm: "280px"
                                      },
                                      overflowY: "auto"
                                    }
                                  }
                                }}
                              />

                              {/* Arrow icon */}
                              <ArrowDropDownIcon
                                onClick={() => {
                                  const btn = document.querySelector(".MuiTelInput-FlagButton");
                                  if (btn) btn.click();
                                }}
                                style={{
                                  position: "absolute",
                                  left: "50px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "#555"
                                }}
                              />

                              {/* Divider */}
                              <div
                                style={{
                                  position: "absolute",
                                  left: "70px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  width: "1px",
                                  height: "35px",
                                  backgroundColor: "#ccc"
                                }}
                              />

                            </div>
                          )}
                        </Field>

                        <ErrorMessage name="phone" component="div" className="text-red-600" style={{color: 'red'}} />
                      </Grid>

                    </Grid>



                    <h2 className="text-3xl font-bold mb-4">Profile Image</h2>

                    <input
                      type="file"
                      name="image"
                      onChange={(e) => {
                        setFieldValue('image', e.target.files[0]);
                        handleImageChange(e);
                      }}
                    />

                    <div className="mt-3">

                      {imagePreview && (

                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{
                            width: '8rem',
                            height: '8rem',
                            objectFit: 'cover'
                          }}
                        />

                      )}

                    </div>



                    <div className="mt-5">

                      <button
                        type="submit"
                        className="submit_btn"
                        disabled={isSubmitting}
                      >

                        {isSubmitting ? 'Updating...' : 'Update Profile'}

                      </button>

                    </div>


                  </Form>

                )}

              </Formik>

            </Grid>

          </Grid>

        </div>

      </section>

    </>

  );

};

export default Profile;